// extracted by mini-css-extract-plugin
export default {"ball-clip-rotate-multiple":"Loading_ball-clip-rotate-multiple__N6oqv","rotate":"Loading_rotate__nGhts"};